import { axiosPublic, axiosPrivate } from "../utils";
import { toast } from 'react-toastify';

export const getAllLabProducts = async (data) => {
    const { labId } = data;
    try {
        const res = await axiosPrivate.get('lab-product/all', {
            params: {
                labId: labId
            }
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const createLabProduct = async (data) => {
    const { labId, name, price } = data;
    try {
        const res = await axiosPrivate.post('lab-product/create', {
            labId: labId,
            name: name,
            price: price
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const viewLabProduct = async (data) => {
    const { productId } = data;
    try {
        const res = await axiosPrivate.get(`lab-product/${productId}`);
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const editLabProduct = async (data) => {
    const { productId, name, price, dentalProcedures, productExtras, materials } = data;
    const productextrasIds = productExtras.map((item) => item._id);
    const productMaterials = materials.map(materialItem => ({
        material: materialItem.material._id,
        quantity: materialItem.quantity
    }));

    try {
        const res = await axiosPrivate.put(`lab-product/edit/${productId}`, {
            name: name,
            price: price,
            dentalProcedures: dentalProcedures,
            productextras: productextrasIds,
            materials: productMaterials
        });
        if (!res.data.result) {
            if (res.data.message) {
            }
            return res.data.message;
        }
        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}